"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Tooltip_1 = __importDefault(require("../Tooltip"));
const InfoIcon_1 = __importDefault(require("../../icons/InfoIcon"));
const FieldLabel = (_a) => {
    var { children, required, additionalLabel, labelInfo } = _a, props = __rest(_a, ["children", "required", "additionalLabel", "labelInfo"]);
    return ((0, jsx_runtime_1.jsxs)("label", Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)("span", { children: children }, void 0), required && (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "label_asterix" }, { children: "*" }), void 0), !!additionalLabel && (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "label_additional" }, { children: ["(", additionalLabel, ")"] }), void 0), !!labelInfo && ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ className: "label_info", theme: "dark", config: { trigger: ['click', 'hover'], placement: 'top' }, content: labelInfo }, { children: (0, jsx_runtime_1.jsx)(InfoIcon_1.default, {}, void 0) }), void 0))] }), void 0));
};
exports.default = FieldLabel;
